import { Injectable } from "@angular/core";
import { CampaignService } from "@edp-services/campaign.service";
import {
    GetBanks,
    GetCodeValidation,
    GetNewCode,
    GetPayment,
    GetPaymentStatus,
    GetSignatureValidation,
    OpenAreaActions,
    SetOpenAreaCampaign,
    SetPaymentHistory
} from "@edp-store/actions/open-area.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, switchMap } from "rxjs/operators";
import { EMPTY, of } from "rxjs";
import { OpenAreaService } from "@edp-services/open-area.service";
import { ELayoutActions, ShowLoader } from "@edp-store/actions/layout.actions";


@Injectable()
export class OpenAreaEffects {
    @Effect()
    loadOpenAreaCampaign$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetOpenAreaCampaing),
        switchMap(() => this.campaignService.getOpenAreaCampaign()),
        switchMap((response: any) => {
            return of( new SetOpenAreaCampaign(response[0].campaign[0]));
        })
    );

    @Effect()
    getSignatureValidation$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetSignatureValidation),
        switchMap((action: GetSignatureValidation) => {
            this.store.dispatch(new ShowLoader(true));
            return this.openAreaService.checkSignature(action.payload).pipe(
                switchMap(response => [
                    { type: OpenAreaActions.SetSignature, payload: response[0] },
                    { type: ELayoutActions.ShowLoader, payload: false },
                ]),
                catchError(() => [
                    { type: ELayoutActions.ShowLoader, payload: false },
                    { type: OpenAreaActions.SetSignature, payload: {Status: "NOK"} },
                ])
            );
        })
    );

    @Effect()
    getCodeValidation$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetCodeValidation),
        switchMap((action: GetCodeValidation) => {
            return this.openAreaService.validateCode(action.payload).pipe(
                switchMap(response => [
                    { type: OpenAreaActions.SetCodeValidation, payload: response[0] },
                ]),
                catchError(() => [
                    { type: ELayoutActions.ShowLoader, payload: false },
                    { type: OpenAreaActions.SetCodeValidation, payload: null },
                ])
            );
        })
    );

    @Effect()
    getBanks$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetBanks),
        switchMap((action: GetBanks) => {
            this.store.dispatch(new ShowLoader(true));
            return this.openAreaService.getBanks(action.payload).pipe(
                switchMap(response => [
                    { type: OpenAreaActions.SetBanks, payload: response[0].bank },
                    { type: ELayoutActions.ShowLoader, payload: false },
                ]),
                catchError(() => [
                    { type: ELayoutActions.ShowLoader, payload: false },
                    { type: OpenAreaActions.SetBanks, payload: []},
                ])
            );
        })
    );

    @Effect()
    getPaymentStatus$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetPaymentStatus),
        switchMap((action: GetPaymentStatus) => {
            this.store.dispatch(new ShowLoader(true));
            return this.openAreaService.getPaymentStatus(action.payload).pipe(
                switchMap(response => {
                    const data = !!response[0].length ? response[0][0] : null;
                    return [
                        { type: OpenAreaActions.SetPaymentStatus, payload: !!data ? data.status : null },
                        { type: ELayoutActions.ShowLoader, payload: false },
                    ];
                }),
                catchError(() => [
                    { type: OpenAreaActions.SetPaymentStatus, payload: null},
                    { type: ELayoutActions.ShowLoader, payload: false },
                ])
            );
        })
    );

    @Effect()
    sendCode$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetNewCode),
        switchMap((action: GetNewCode) => this.openAreaService.sendCode(action.payload)),
        switchMap((response) => [
            { type: OpenAreaActions.SetNewCode, payload: response[0] },
        ])
    );

    @Effect()
    getPayment$ = this.actions$.pipe(
        ofType(OpenAreaActions.GetPayment),
        switchMap((action: GetPayment) => {
            this.store.dispatch(new ShowLoader(true));
            return this.openAreaService.getPayment(action.payload).pipe(
                switchMap(response => [
                    { type: OpenAreaActions.SetPayment, payload: response[0] },
                    { type: ELayoutActions.ShowLoader, payload: false },
                ]),
                catchError(() => [
                    { type: OpenAreaActions.SetPayment, payload: {Status: "NOK"}},
                    { type: ELayoutActions.ShowLoader, payload: false },
                ])
            );
        })
    );

    @Effect()
    setPaymentHistory$ = this.actions$.pipe(
        ofType(OpenAreaActions.SetPaymentHistory),
        switchMap((action: SetPaymentHistory) => this.openAreaService.setPaymentHistory(action.payload)),
        switchMap(() => {
            return EMPTY;
        })
    );

    constructor(
        private actions$: Actions,
        private campaignService: CampaignService,
        private openAreaService: OpenAreaService,
        private store: Store<IAppState>
    ) {}
}
